import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

interface ModuleCardProps {
  title: string;
  description: string;
  icon: React.ReactElement;
  onClick?: () => void;
}

export const ModuleCard: React.FC<ModuleCardProps> = ({
  title,
  description,
  icon,
  onClick,
}) => {
  return (
    <Card
      sx={{
        height: '200px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 8px 25px rgba(160, 88, 142, 0.15)',
        },
      }}
      onClick={onClick}
    >
      <CardContent
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: 3,
        }}
      >
        <Box
          sx={{
            color: '#a0588e',
            marginBottom: 2,
            fontSize: '3rem',
          }}
        >
          {icon}
        </Box>
        <Typography
          variant="h6"
          component="h2"
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 600,
            color: '#000000',
            marginBottom: 1,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontFamily: 'Poppins, sans-serif',
            color: '#666666',
            textAlign: 'center',
          }}
        >
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}; 